import React from "react";
import {Col, Tabs, Row, Tag, Button, Carousel, BackTop} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, } from "@reco-w/core-ui";
import { Namespaces } from "@reco-w/aliyun-models";
import { Consulting } from "src/apps/consulting/consulting";
import { parkhelperText } from "@reco-w/common-common";

const { TabPane } = Tabs;

export namespace Aliyun {
    export interface IProps extends ViewComponent.IProps { }

    export interface IState extends ViewComponent.IState { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.aliyun;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", "aliyun"); // 设置被选中的菜单
        }
        componentDidMount() {
            const idx = this.getSearchParam("idx", this.props);
            if (idx) {
                this.tabSetChang(+idx);
            } else {
                this.tabSetChang(0);
            }
        }
        tabSetChang(e) {
            this.dispatch({ type: "input", data: { index: e + 1 } });
        }

        renderBody(): React.ReactNode {
            const data = ["上云补贴", "企业邮箱", "门户建站", "案例&资质"];
            const { state } = this.props,
                index = state!.index || 1,
                isModalVisible = state!.isModalVisible;

            return (
                <div className="content">
                    <div className="home-box type2">
                        <Carousel>
                            <div className={"item"}>
                                <img alt={""} src={"assets/images/waiter/banner4.jpg?v=20220608"} />
                                <div className={"container"}>
                                    <div className="banner-main">
                                        <div className="home-banner-desc mb30">特申补贴</div>
                                        <div className="home-banner-title">
                                            1、专属阿里云补贴<span className="text1">10</span>%-<span className="text1">20</span>%
                                        </div>
                                        <div className="home-banner-title mv15">
                                            2、尊贵阿里云补贴<span className="text1">100</span>%
                                        </div>
                                        <div className="home-banner-title">
                                            3、加入<span className="text1">VIP</span>额外补贴，最高<span className="text1">20</span>万，参加专属限时阿里云优惠活动
                                        </div>
                                        <a onClick={() => this.goTo("/aliyun")}>
                                            <Button
                                                type={"primary"}
                                                size={"large"}
                                                className="banner-button-link "
                                                onClick={() => {
                                                    this.dispatch({ type: "input", data: { isModalVisible: true } });
                                                }}
                                            >
                                                立即申请
                                            </Button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                    <div className="home-box3">
                        <div className="text1">特申补贴</div>
                        <div className="text2">
                            1、专属阿里云补贴<span className="text1">10</span>%-<span className="text1">20</span>%
                        </div>
                        <div className="text2">
                            2、尊贵阿里云补贴<span className="text1">100</span>%
                        </div>
                        <div className="text2 mb10">
                            3、加入<span className="text1">VIP</span>额外补贴，最高<span className="text1">20</span>万，参加专属限时阿里云优惠活动
                        </div>
                        <a onClick={() => this.goTo("/aliyun")}>
                            <Button
                                type={"primary"}
                                size={"large"}
                                className="banner-button-link "
                                onClick={() => {
                                    this.dispatch({ type: "input", data: { isModalVisible: true } });
                                }}
                            >
                                立即申请
                            </Button>
                        </a>
                    </div>
                    <div className="tabs-nav">
                        <div className={"container"}>
                            {data.map((item, i) => {
                                return (
                                    <div className={index === i + 1 ? "item active" : "item"} key={i} onClick={() => this.tabSetChang(i)}>
                                        {item}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <Tabs className="tabs-body" activeKey={String(index)}>
                        <TabPane key="1">
                            <div className="details-panel">
                                <div className="title">申请流程</div>
                                <div className="container">
                                    <img className="liucheng1" src="assets/images//waiter/liucheng.png?v=20220930" />
                                    <img className="liucheng2" src="assets/images//waiter/liucheng2.png" />
                                </div>
                            </div>
                            <div className="details-panel">
                                <div className="title">市面最高上云补贴</div>
                                <div className="container">
                                    <div className="desc ">
                                        <p className="text-center">
                                            联合阿里云创新中心（张江·临港·松江·津南·丽水遂昌）基地、 阿里云创新中心-宝马初创车库（上海金桥）联合创新基地及RECO SPACE
                                            （嘉定基地），针对中小微创新创业使用阿里云资源给予补贴。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="details-panel" style={{ marginBottom: '100px' }}>
                                <div className="title">常见问题</div>
                                <div className="container">
                                    <Row gutter={[115, 50]}>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：如何获取折扣或者补贴？</div>
                                                <div className="text2">
                                                    答：客户提供企业名称或者手机号、邮箱地址给到客户经理；由客户经理发送阿里云官方注册链接到客户邮箱，由客户按步骤在阿里云官网进行注册并实名认证。其中企业账号的产品使用范围及优惠力度大多数高于个人账号。之后在相应账号下下单购买产品，可以获得相应比例的补贴。
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：客户已经有老账号了可以合作吗？</div>
                                                <div className="text2">
                                                    答：可以通过项目报备的形式进行合作；如果客户正好有新公司新项目，也可以通过注册账号进行合作。
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：购买阿里云服务器，注册关联帐号的链接几天内有效？</div>
                                                <div className="text2">
                                                    答：发到客户邮箱的注册关联链接是在24小时内（1天）有效的，请收到关联邮件后即刻操作关联。
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：支付宝不能实名认证了，提示绑定手机号超限是什么规则？</div>
                                                <div className="text2">
                                                    答：一个支付宝账号只能实名认证5个阿里云账号，一个手机号也只能绑定5个阿里账号。
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：不懂阿里云怎么使用，瑞谷云企有哪些方面可以服务？</div>
                                                <div className="text2">答：瑞谷云企有专业的技术团队，可以协助客户进行服务器选型、配置、补贴以及完善的售后保障服务等。</div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">答：瑞谷云企有专业的技术团队，可以协助客户进行服务器选型、配置、补贴以及完善的售后保障服务等。</div>
                                                <div className="text2">
                                                    答：客户购买的产品是客户的私人物品，操作都是在阿里云官网上，除客户自身以外，其他人都是没有权限查看和操作。
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：阿里云的ECS服务器可以先试用么？试用得好，我们再买多年都是可以的。</div>
                                                <div className="text2">答：可以选择所需配置按量付费做测试，也可以选择包年包月的购买1周的服务来先做测试用。在测试过程中有什么问题随时联系瑞谷云企协助客户解决。</div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：购买阿里云服务器能退款吗？</div>
                                                <div className="text2">
                                                    答：阿里云官方承诺5天内无理由退款，故障100倍赔偿，备案多久时间赠送多久时间，阿里云官方7×24小时售后服务，真正做到购买无忧、使用无忧。除此以外，还有阿里云服务器访问异常问题排查指引。
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：购买了阿里云能开发票吗？发票金额是多少？合同怎么申请呢？</div>
                                                <div className="text2">答：发票申请是直接在客户的阿里云账号的费用中心申请，发票的金额是阿里云产品的购买价格（注：发票填写只能填写一次后期就不能修改了）；合同有草稿合同和正式合同，如果需要合同申请款项， 需要先把配置选好提交订单 然后就可以申请草稿合同了，等订单支付成功后是可以转为正式合同的。</div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：阿里云账号的余额是否可以申请提现？</div>
                                                <div className="text2">
                                                    答：可以提现的，但要看余额是之前没有消费完的还是退款的余额。没有消费完的余额申请提现很快，但是如果是退款的余额而且之前有开过发票，是需要先把发票退回给阿里云财务后再按照流程一步一步操作申请提现，大概需要几个工作日。
                                                </div>
                                            </div>
                                        </Col>

                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：阿里云服务器按量付费是否有折扣？ 后期根据需求是否可以升级配置呢?</div>
                                                <div className="text2">答：按量付费是没有折扣的，因为根据配置的需求结算出来的价格是以每小时收费，而且按量付费的产品是不能升级配置的。所以一般建议重新购买按年付的 相对比较划算的。</div>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={12} xxl={12}>
                                            <div className="wenda">
                                                <div className="text1">问：简单的商城网站，用什么配置的服务器合适呢？</div>
                                                <div className="text2">
                                                    答：如果是企业网站，用一般的配置就可以了，服务器每年价格在5k左右，具体还要看网站每天访问人数或者同一时间访问的人数等来确定具体配置。ECS服务器是随时都可以升降配置的，所以不用担心配置不够用。如果对购买配置把握不准，可以咨询瑞谷云企的专业客服。
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* <Row justify="center">
                                        <Col xs={12} lg={4} xxl={2}>
                                            <Button
                                                size="large"
                                                type="primary"
                                                className="mv50"
                                                block
                                                onClick={() => {
                                                    this.goTo("problem");
                                                }}
                                            >
                                                查看全部
                                            </Button>
                                        </Col>
                                    </Row> */}
                                </div>
                            </div>

                            <Consulting.Page orderCode="guanwqysy" />
                        </TabPane>
                        <TabPane key="2">
                            <div className="container">
                                <div className="details-panel">
                                    <div className="title">企业邮箱</div>
                                    <div className="desc">
                                        <p>
                                            阿里企业邮箱包含<span>标准版、集团版、尊享版</span>
                                            ，可满足不同企业的需求。企业邮箱囊括了邮件归档、多域管理、邮箱搬家、动态邮件组等功能，功能全面，性能稳定，让企业管理更加
                                            <span>高效轻松</span>。
                                        </p>
                                    </div>
                                    <div className="title">邮箱补贴</div>
                                    <Row gutter={[30, 30]} className="mb80">
                                        <Col xs={24} lg={8} xxl={8}>
                                            <div className="box-content">
                                                <Row gutter={[20, 12]}>
                                                    <Col span="24">
                                                        <div className="tit">
                                                            标准版邮箱新购&续费
                                                            <Tag className="ml5" color="#ff6a00">
                                                                9折起
                                                            </Tag>
                                                        </div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">单账号不限容量</div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">10G大附件中转站</div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">20G企业网盘</div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">5G个人网盘</div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">数据监控+备份</div>
                                                    </Col>
                                                    <Col span="24">
                                                        <div className="price">
                                                            <span>¥600.00</span>
                                                            <em>元/5账号/年</em>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={8} xxl={8}>
                                            <div className="box-content">
                                                <Row gutter={[20, 12]}>
                                                    <Col span="24">
                                                        <div className="tit">
                                                            尊享版邮箱新购&续费
                                                            <Tag className="ml5" color="#ff6a00">
                                                                8折起
                                                            </Tag>
                                                        </div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">单账号不限容量</div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">32G大附件中转站</div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">100G企业网盘</div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">16G个人网盘</div>
                                                    </Col>
                                                    <Col span="12">
                                                        <div className="text">数据监控+备份</div>
                                                    </Col>
                                                    <Col span="24">
                                                        <div className="price">
                                                            <span>¥980.00</span>
                                                            <em>元/10账号/年</em>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col xs={24} lg={8} xxl={8}>
                                            <div className="box-content">
                                                <Row gutter={[20, 12]}>
                                                    <Col span="24">
                                                        <div className="tit">
                                                            集团版邮箱新购&续费
                                                            <Tag className="ml5" color="#ff6a00">
                                                                7折起
                                                            </Tag>
                                                        </div>
                                                    </Col>
                                                    <Col span="24">
                                                        <div className="text omit omit-1">含标准版所有功能</div>
                                                    </Col>
                                                    <Col span="24">
                                                        <div className="text omit omit-1">子公司独立域独立权限管理</div>
                                                    </Col>
                                                    <Col span="24">
                                                        <div className="text omit omit-1">子公司独立企业通讯录</div>
                                                    </Col>
                                                    <Col span="24">
                                                        <div className="price omit omit-1">
                                                            <span>¥9500.00</span>
                                                            <em>元/100账号/年（100账号起买）</em>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="details-panel" style={{ backgroundColor: "rgb(251, 250, 250)" }}>
                                <div className={"title"}>产品优势</div>
                                <Row justify="center" className="pb75">
                                    <img className="img-full" src="assets/images/icon-img-aliyun.png" alt="" />
                                </Row>
                            </div>
                            <Consulting.Page></Consulting.Page>
                        </TabPane>
                        <TabPane key="3">
                            <div className="container">
                                <div className="details-panel">
                                    <div className="title">门户建站</div>
                                    <div className="desc">
                                        <p>
                                            云· 企业官网是一款标准化定制建站服务，集成主流网站的常见功能模块及阿里云计算资源。而现在通过{parkhelperText}，企业可以以更低的成本享受
                                            <span>定制化企业官网服务</span>。
                                        </p>
                                    </div>
                                    <div className="table-box pb50">
                                        <div className="size-20 mt40 mb15">
                                            <strong>1.高级版企业官网补贴：5%-10%补贴(特定区域50%-80%补贴)</strong>
                                        </div>
                                        <div className="table-row">
                                            <div className="title">
                                                <div>设计与制作</div>
                                                <div>网站功能</div>
                                                <div>云资源配置</div>
                                            </div>
                                            <div className="rows">
                                                <div>整站设计</div>
                                                <div>可视化网站管理后台</div>
                                                <div>网站空间500G/流量不限</div>
                                            </div>
                                            <div className="rows">
                                                <div>页面制作15个</div>
                                                <div>页面管理</div>
                                                <div>阿里云2G空间视频服务</div>
                                            </div>
                                            <div className="rows">
                                                <div>新闻/产品预置15个</div>
                                                <div>新闻管理</div>
                                                <div>阿里云短信服务</div>
                                            </div>
                                            <div className="rows">
                                                <div>双语言制作</div>
                                                <div>产品管理</div>
                                                <div>云盾安全服务</div>
                                            </div>
                                            <div className="rows">
                                                <div>手机网站独立设计</div>
                                                <div>12个月会员管理</div>
                                                <div>赠送SSL证书</div>
                                            </div>
                                            <div className="rows">
                                                <div></div>
                                                <div>万能表单</div>
                                                <div></div>
                                            </div>
                                            <div className="rows">
                                                <div></div>
                                                <div>网站SEO</div>
                                                <div></div>
                                            </div>
                                        </div>
                                        <div className="size-20 mt40 mb15">
                                            <strong>2.尊贵版企业官网补贴：15%-25%补贴</strong>
                                        </div>
                                        <div className="table-row">
                                            <div className="title">
                                                <div>设计与制作</div>
                                                <div>网站功能</div>
                                                <div>云资源配置</div>
                                            </div>
                                            <div className="rows">
                                                <div>整站设计</div>
                                                <div>可视化网站管理后台</div>
                                                <div>云服务器及数据库</div>
                                            </div>
                                            <div className="rows">
                                                <div>页面制作20个</div>
                                                <div>页面管理</div>
                                                <div>12个月独享IP，独享100Mbps</div>
                                            </div>
                                            <div className="rows">
                                                <div>新闻/产品预置20个</div>
                                                <div>新闻管理</div>
                                                <div>CDN网络加速服务</div>
                                            </div>
                                            <div className="rows">
                                                <div>双语言制作</div>
                                                <div>产品管理</div>
                                                <div>网站空间不限/流量不限</div>
                                            </div>
                                            <div className="rows">
                                                <div>手机网站独立设计</div>
                                                <div>会员管理</div>
                                                <div>阿里云3G空间视频服务</div>
                                            </div>
                                            <div className="rows">
                                                <div>手机网站独立设计</div>
                                                <div>电商及支付</div>
                                                <div>阿里云短信服务</div>
                                            </div>
                                            <div className="rows">
                                                <div></div>
                                                <div>万能表单</div>
                                                <div>云盾安全服务</div>
                                            </div>
                                            <div className="rows">
                                                <div></div>
                                                <div>网站SEO</div>
                                                <div>赠送SSL证书</div>
                                            </div>
                                        </div>
                                        <div className="size-20 mt40 mb15">
                                            <strong>3.行业定制版企业官网补贴：15%-25%补贴</strong>
                                        </div>
                                        <div className="table-row">
                                            <div className="title">
                                                <div>设计与制作</div>
                                                <div>网站功能</div>
                                                <div>云资源配置</div>
                                            </div>
                                            <div className="rows">
                                                <div>全案策划及视觉设计</div>
                                                <div>集成后台管理系统（CMS）</div>
                                                <div>免费提供云计算系统架构方案设计</div>
                                            </div>
                                            <div className="rows">
                                                <div>页面按需定制</div>
                                                <div>支持页面个性化效果</div>
                                                <div>独立IP，独享带宽</div>
                                            </div>
                                            <div className="rows">
                                                <div>历史数据迁移</div>
                                                <div>开放API数据接口</div>
                                                <div>集成CDN网络加速</div>
                                            </div>
                                            <div className="rows">
                                                <div>多语翻译及制作</div>
                                                <div>支持数据导入</div>
                                                <div>支持阿里云ECS及RDS、OSS独立部署</div>
                                            </div>
                                            <div className="rows">
                                                <div>手机网站独立设计</div>
                                                <div>支持多角色权限管理审核</div>
                                                <div>网站等级保护</div>
                                            </div>
                                            <div className="rows">
                                                <div></div>
                                                <div>支持政府、集团网站集群</div>
                                                <div>阿里云全功能套件集成</div>
                                            </div>
                                            <div className="rows">
                                                <div></div>
                                                <div>小程序定制开发及对接</div>
                                                <div>云盾安全体系及运维保障</div>
                                            </div>
                                            <div className="rows">
                                                <div></div>
                                                <div>APP定制开发及对接</div>
                                                <div>赠送SSL证书</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="details-panel" style={{ backgroundColor: "rgb(251, 250, 250)" }}>
                                <div className={"title"}>产品优势</div>
                                <Row justify="center" className="pb75">
                                    <img className="img-full" src="assets/images/icon-img-aliyun.png" alt="" />
                                </Row>
                            </div>
                            <Consulting.Page></Consulting.Page>
                        </TabPane>
                        <TabPane key="4">
                            <div className="container">
                                <div className="details-panel">
                                    <div className="title">资质证书</div>
                                    <div className="desc">
                                        <p>
                                            上海瑞谷传祺创业投资管理有限公司已成为了阿里云精英级合作伙伴，并先后成立阿里云创新中心（张江·临港·松江·津南·武陟）、阿里云创新中心-宝马初创车库联合创新基地（上海金桥）及RECO
                                            SPACE（嘉定基地），并授权瑞谷云企针对中小微创新企业提供企业数字化服务。截止目前，瑞谷云企已经服务了数千家企业，并已有数百家企业申请成为瑞谷云企VIP会员。
                                        </p>
                                    </div>
                                    <div className="zs-img">
                                        <img width="100%" src="assets/images/jyjrz.jpg" />
                                    </div>
                                    {/* <Row gutter={[36, 36]} style={{ margin: "50px 0 165px 0" }}>
                                        <Col xs={24} lg={8} xxl={8}>
                                            <ImageAuto.Component width="100%" height="533px" src="assets/images/honor2.png" />
                                        </Col>
                                        <Col xs={24} lg={8} xxl={8}>
                                            <ImageAuto.Component width="100%" height="533px" src="assets/images/honor3.png" />
                                        </Col>
                                        <Col xs={24} lg={8} xxl={8}>
                                            <ImageAuto.Component width="100%" height="533px" src="assets/images/honor4.png" />
                                        </Col>
                                        <Col xs={24} lg={8} xxl={8}>
                                            <ImageAuto.Component width="100%" height="533px" src="assets/images/honor5.png" />
                                        </Col>
                                        <Col xs={24} lg={8} xxl={8}>
                                            <ImageAuto.Component width="100%" height="533px" src="assets/images/honor6.png" />
                                        </Col> 
                                    </Row>*/}
                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                    {isModalVisible && (
                        <Consulting.Page
                            isModal={true}
                            modalCancel={() => {
                                this.dispatch({ type: "input", data: { isModalVisible: false } });
                            }}
                        ></Consulting.Page>
                    )}

                    <div className="scoll-top">
                        <BackTop visibilityHeight={50} />
                    </div>
                </div>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.aliyun]);
}
